import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
// Self-hosted variable fonts for Devanagari (Hindi) and Gujarati scripts.
// Loading only the "wght" variable axis keeps this < 60 KB per script and
// no external CDN fetch is required. Font-family names come from the
// package (`Noto Sans Devanagari Variable`, `Noto Sans Gujarati Variable`).
import "@fontsource-variable/noto-sans-devanagari";
import "@fontsource-variable/noto-sans-gujarati";
import App from "@/App";

/* ── Dev-only accessibility linter ────────────────────────────────
 * @axe-core/react scans every render and logs WCAG violations to the
 * browser console. It is initialized only in development and never runs
 * in production builds (no perf cost for end-users).
 * See /app/frontend/src/lib/a11y-dev.js for config.
 * ─────────────────────────────────────────────────────────────── */
if (process.env.NODE_ENV === "development") {
  const axe = require("@axe-core/react");
  axe(React, ReactDOM, 1000, {
    rules: [
      // Enable the standard WCAG 2.1 AA rule set (colour-contrast, aria-*, labels, etc.)
    ],
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
